import { polyLine2IsRectangle, polyLine2Area, polyLine2IsSelfIntersecting } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";

/**
 * degenerate rectangles (with zero depth or width) are technically valid block outlines,
 * though they will generate no geometry
 */

export function isValidBlockRectangle(rect: PolyLine2): boolean {
  return polyLine2IsRectangle(rect, true);
}
/**
 * when creating a new stair block, the outline can be any polygon
 * that is not zero-area or self-intersecting
 */

export function isValidNewBlockPolyLine2(pl: PolyLine2): boolean {
  return polyLine2Area(pl) > 0 && !polyLine2IsSelfIntersecting(pl);
}
